<script setup lang="ts">
import type { RefType } from '~/types/commons'

const props = withDefaults(defineProps<{
  isCrossedSearch?: boolean
}>(), {
  isCrossedSearch: false,
})

const modelValue = defineModel<string[]>({ required: true })

const { equipmentsCategories } = useSearchFiltersOptionsEquipments()

const crossedSearchExcluded = ['baby_seat', 'barbecue', 'automatic_gear']
const isEquipementDisplayed = (equipement: string) => !crossedSearchExcluded.includes(equipement)
const filterDisplayedEquipement = (equipements: RefType<typeof equipmentsCategories>[string]['options']) => props.isCrossedSearch ? equipements.filter(eq => isEquipementDisplayed(eq.value)) : equipements

const equipmentCategoryIconMap = computed(() => ({
  inside: resolveComponent('YscIconsShower'),
  outside: resolveComponent('YscIconsOutdoor'),
  driving: resolveComponent('YscIconsDriving'),
  safety: resolveComponent('YscIconsChildSeats'),
  winter: resolveComponent('YscIconsSnowflake'),
}))

defineEmits<{
  submit: []
}>()
</script>

<template>
  <form
    id="search-form-equipments"
    class="max-h-[calc(100vh-15rem)] w-96 overflow-y-auto"
    @submit.prevent="$emit('submit')"
  >
    <AppSearchFilterFormSection
      v-for="eq in (['inside', 'outside', 'driving', 'safety', 'winter'] as const)"
      :key="`equipments_list_${eq}`"
    >
      <template #title>
        <h3 class="font-semibold flex items-center">
          <component
            :is="equipmentCategoryIconMap[eq]"
            v-if="eq in equipmentCategoryIconMap"
            class="mr-2 inline h-6 w-6"
          />

          {{ equipmentsCategories[eq].title }}
        </h3>
      </template>

      <YscInputCheckbox
        v-for="opt in filterDisplayedEquipement(equipmentsCategories[eq].options)"
        :id="`equipements_${opt.value}`"
        :key="opt.value"
        v-model="modelValue"
        name="filters-equipment"
        class="flex-row-reverse justify-between !space-x-0 w-full"
        is-block
        :value="opt.value"
      >
        {{ opt.text }}
      </YscInputCheckbox>
    </AppSearchFilterFormSection>
  </form>
</template>
